module.exports = __webpack_public_path__ + "static/media/facebook.5250f6be.svg";